mama-anker-navigation {
  display: block;
  width: 100%;
  margin-bottom: 2rem;

  @include media-breakpoint-up(lg) {
    display: flex;
    justify-content: flex-end;
    padding-left: 5rem;
  }

  @include media-breakpoint-up(xl) {
    padding-left: 6.75rem;
  }

  label {
    color: var(--theme-body-color, $mm-black-blue);
    font-size: $font-size-2xs;
    line-height: $line-height-2xs;
    font-weight: $font-weight-bold;
    margin-bottom: 0.3125rem;

    @include media-breakpoint-up(lg) {
      font-size: $font-size-xs;
      color: var(--theme-color, $mm-petrol);
      margin-bottom: 0.5rem;
    }
  }

  .navigation-mobile {
    @include media-breakpoint-up(lg) {
      display: none;
    }

    .form-group {
      padding-top: 0;
      margin-bottom: 0;
    }

    .form-control {
      border: 0;
      height: 56px;
      border-radius: 0.5rem;
      padding-left: 1.25rem;
    }

    svg {
      position: absolute;
      top: 1rem;
      right: 1.25rem;
      width: 1.5rem;
      height: 1.5rem;
      fill: var(--theme-body-color, $mm-black-blue);
    }
  }

  .navigation-desktop {
    display: none;

    @include media-breakpoint-up(lg) {
      display: block;
    }

    a {
      display: block;
      color: var(--theme-body-color, $mm-black-blue);
      font-size: $font-size-xs;
      line-height: $line-height-2xs;
      font-weight: $font-weight-bold;
      text-decoration: underline;

      + a {
        margin-top: 0.5rem;
      }
    }
  }
}
